import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';

import {
	reqGET,
	reqPOST,
	reqPUT,
} from '../../../Utils';

import { api_list_route } from './Config';
import UseSidebar from '../../../UseSidebar';

import Swal from 'sweetalert2'

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [isloading, setLoading] = useState(true);

	const [save_label, set_save_label] = useState('Salvar');

	const [is_edit, set_is_edit] = useState(false)

	// PARA INSTANCIAR O COMPONENTE COM O ID 
	//const props_tmp = props
	useEffect(() => {
		const fetch_id_info = async (id_serch) => {
			return await reqGET(`${api_list_route(getTokenInfo().companycode)}/${id_serch}`)
				.then(res => {
					set_dados(dados.current = res.data[0]);
				})
				.catch(error => console.log(error))
		}

		//console.log('OIIIIIIIIIIIII')
		const clean_data = () => {
			// DEEP COPY OF data_interface 
			set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
			set_dados(dados.current.permissions.companycode = getTokenInfo().companycode)
		}

		set_save_label('Salvar')
		clean_data();

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//console.log('NO EDIT')

				fetch_id_info(props.location.state.item['id']).then(
					() => {

						set_is_edit(true)
						setLoading(false)

						// CASO AINDA NÃO EXISTA INFORMAÇÃO 
						//if (dados.current.info.menu.length === 0) {

						//console.log('DADOS CURRENT INFO IGUAL A  ==', dados.current.name)
						//set_dados(dados.current.info.menu = UseSidebar().getSidebar.then(v => dados.current.info.menu = v))
						UseSidebar().getSidebar(dados.current.name, true).then(v => {
							console.log('FROM USESIDEBAR', v);
							set_dados(dados.current.permissions.menu = v)
						})

						return
					}
				)
			}

		} 
		catch {
			clean_data()

			setLoading(false);
			// VAI REGISTAR
			//console.log('PERFISMENUS NEW REGIST')
			//console.log('DADOS CURRENT INFO IGUALA  ==', dados.current.info.name)
			//set_dados(dados.current.info.menu = UseSidebar().getSidebar.then(v => dados.current.info.menu = v))



			//Verificar 
			UseSidebar().getSidebar(null).then(v => { 
			
				console.log('-->', v)
				set_dados(dados.current.permissions.menu = v) 
			})
		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		//console.log('------------NO SUBMIT-------------')
		let guardarLink = endpoints.list

		if (is_edit === true) {
			//alert('Atualizar PUT')

			//console.log('EDIA')

			// PROFILES UPDATE IN ENTITIES

			//console.log('CURRRRRRRRENT:', dados.current)

			// const api_list_route_entities = companycode => `${api_crud_base}/entities/special/list/${companycode}/${dados.current.name}`

			// let entities_route = api_list_route_entities(getTokenInfo().companycode)
			//console.log('NO SUBMIT 1', entities_route)


			/*
			let temp_profile = {
				name: dados.current.name,
				companycode: dados.current.permissions.companycode,
				menu: dados.current.permissions.menu
			};
			*/	
			
			try {
								
				await reqPUT(api_crud_route, dados.current)
					.then(() => Swal.fire('', 'Registo Atualizado com Sucesso!', 'info')) //window.location.reload())//alert('Registo Atualizado com Sucesso!'))
					.catch(() => Swal.fire('', 'Problema ao atualizar Registo!', 'info'))

			} catch {
				//console.log('NO CATCH')
				props.history.push(guardarLink)
			}
		}
		else {
			//console.log('---------------> NO POST')
			reqPOST(api_crud_route, dados.current)
				.then(() => Swal.fire('', 'Registo Inserido com Sucesso!', 'info'))
				.catch(() => Swal.fire('', 'Problema ao atualizar Registo!', 'info'))

			props.history.push(guardarLink)
		}

	}

	const handle_change_name = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/
		/* 
			console.log('NAME:' + name)
			console.log('Value:' + value)
		*/
		set_dados(dados.current.permissions[name] = value)
		set_dados(dados.current[name] = value)

		/*console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))*/

	}

	const handleSingleCheck = e => {
		const { name } = e.target;

		let ver_submenu = (node) => {
			if (node.submenu.length !== 0) {
				node.submenu.forEach(subitem => {

					if (subitem.id === name) {
						subitem.allow = !subitem.allow
					}
					else if (name === (subitem.id + '_create')) {
						if (subitem.create === undefined) {
							subitem.create = true
						}
						else {
							subitem.create = !subitem.create
						}
					}
					else if (name === (subitem.id + '_edit')) {
						if (subitem.edit === undefined) {
							subitem.edit = true
						}
						else {
							subitem.edit = !subitem.edit
						}
					}
					else if (name === (subitem.id + '_remove')) {
						if (subitem.remove === undefined) {
							subitem.remove = true
						}
						else {
							subitem.remove = !subitem.remove
						}
					}
					else if (name === (subitem.id + '_dash')) {
						if (subitem.dash === undefined) {
							subitem.dash = true
						}
						else {
							subitem.dash = !subitem.dash
						}
					}
					else if (name === (subitem.id + '_admin')) {
						if (subitem.admin === undefined) {
							subitem.admin = true
						}
						else {
							subitem.admin = !subitem.admin
						}
					}
					else if (name === (subitem.id + '_identificacao')) {
						if (subitem.identificacao === undefined) {
							subitem.identificacao = true
						}
						else {
							subitem.identificacao = !subitem.identificacao
						}
					}
					else if (name === (subitem.id + '_interlocutores')) {
						if (subitem.interlocutores === undefined) {
							subitem.interlocutores = true
						}
						else {
							subitem.interlocutores = !subitem.interlocutores
						}
					}
					else if (name === (subitem.id + '_naturalidade')) {
						if (subitem.naturalidade === undefined) {
							subitem.naturalidade = true
						}
						else {
							subitem.naturalidade = !subitem.naturalidade
						}
					}
					else if (name === (subitem.id + '_fiscal')) {
						if (subitem.fiscal === undefined) {
							subitem.fiscal = true
						}
						else {
							subitem.fiscal = !subitem.fiscal
						}
					}
					else if (name === (subitem.id + '_contrato')) {
						if (subitem.contrato === undefined) {
							subitem.contrato = true
						}
						else {
							subitem.contrato = !subitem.contrato
						}
					}
					else if (name === (subitem.id + '_associacao')) {
						if (subitem.associacao === undefined) {
							subitem.associacao = true
						}
						else {
							subitem.associacao = !subitem.associacao
						}
					}
					else if (name === (subitem.id + '_funcoes')) {
						if (subitem.funcoes === undefined) {
							subitem.funcoes = true
						}
						else {
							subitem.funcoes = !subitem.funcoes
						}
					}
					else if (name === (subitem.id + '_configuracoes')) {
						if (subitem.configuracoes === undefined) {
							subitem.configuracoes = true
						}
						else {
							subitem.configuracoes = !subitem.configuracoes
						}
					}
					else {
						ver_submenu(subitem)
					}

				})
			}
		}

		dados.current.permissions.menu.forEach(node => {

			if (node.id === name) {
				node.allow = !node.allow
			}
			else if (name === (node.id + '_create')) {
				if (node.create === undefined) {
					node.create = true
				}
				else {
					node.create = !node.create
				}
			}
			else if (name === (node.id + '_edit')) {
				if (node.edit === undefined) {
					node.edit = true
				}
				else {
					node.edit = !node.edit
				}
			}
			else if (name === (node.id + '_remove')) {
				if (node.remove === undefined) {
					node.remove = true
				}
				else {
					node.remove = !node.remove
				}
			}
			else if (name === (node.id + '_dash')) {
				if (node.dash === undefined) {
					node.dash = true
				}
				else {
					node.dash = !node.dash
				}
			}
			else if (name === (node.id + '_admin')) {
				if (node.admin === undefined) {
					node.admin = true
				}
				else {
					node.admin = !node.admin
				}
			}			
			else {
				ver_submenu(node)
			}

		})

		// set_dados(dados.current.permissions.menu = dados.current.permissions.menu)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
		console.log('Dados Current:', dados.current.permissions.menu)
		return
	}

	return isloading ?
		<main>
			<div className={`dash-cards-2 header`}>
				<h2 className="dash-title">LOADING</h2>
				<p>LOADING</p>
				<div className="overlay">
					<div className="overlay__inner">
						<div className="overlay__content"><span className="spinner"></span></div>
					</div>
				</div>
			</div>
		</main>
		:
		<main>
			<div className={`dash-cards-2 header`}>
				<h2 className="dash-title">Perfil</h2>
				<p>Home / Perfis / Inserir Perfil</p>
			</div>

			<div className={`dash-cards-2 body`}>
				<div className="card">
					<div className="card-body">

						<form id="form" onSubmit={handleSubmit}>
							<h2 className="dash-title">Perfil</h2>
							<div className="form-group">
								<span className="flex-1">
									<label>Nome do Perfil</label>
									<input type="text" name="name" value={dados.current.name} pattern="[a-zA-Z\u00C0-\u00FF ]+" className="form-control mb-3 mb-lg-0 rounded-0" placeholder="Introduza o nome" onChange={handle_change_name} required />
								</span>
							</div>

							<h2 className="dash-title">Menus</h2>
							<div className="form-group">
								<span className="flex-1">
									<label >Lista de Entradas Disponíveis</label>
									<br />
									{
										dados?.current?.permissions?.menu !== undefined ?
											dados.current.permissions.menu.map((item, key) => {

												if (item.title === '')
													return <div key={key}></div>
												else
													return (
														<div key={key} className='div-list ps-4'>
															<div className="d-flex py-4">
																<span className="flex-1 mb-0">
																	<div className='d-flex'>
																		<i className={"bi bi-" + (item.icon !== '' ? item.icon : 'dash-lg invisible') + " fs-5 me-4"}></i>
																		<label key={key} className="div-checkbox fs-5 mb-0">
																			<strong>{item.title}</strong>
																			<input
																				name={item.id}
																				className="checkbox-form"
																				type="checkbox"
																				value={item.title}
																				onChange={handleSingleCheck}
																				defaultChecked={item.allow}
																			/>
																			<span key={key} className="checkmark"></span>
																		</label>
																	</div>
																</span>
																<span className="flex-2 mb-0">
																	{
																		// item.path.trim() !== '' && item.path.trim() !== '/' ?
																		<ul className='list-unstyled mb-0'>
																			{
																				item.create !== undefined ?
																					<li>
																						<label className="div-checkbox fs-5 mb-3">
																							Criar
																							<input
																								name={item.id + '_create'}
																								className="checkbox-form"
																								type="checkbox"
																								onChange={handleSingleCheck}
																								defaultChecked={item.create}
																							/>
																							<span className="checkmark"></span>
																						</label>
																					</li>
																					:
																					null
																			}
																			{
																				item.edit !== undefined ?
																					<li>
																						<label className="div-checkbox fs-5 mb-3">
																							Editar
																							<input
																								name={item.id + '_edit'}
																								className="checkbox-form"
																								type="checkbox"
																								onChange={handleSingleCheck}
																								defaultChecked={item.edit}
																							/>
																							<span className="checkmark"></span>
																						</label>
																					</li>
																					:
																					null
																			}
																			{
																				item.remove !== undefined ?
																					<li>
																						<label className="div-checkbox fs-5 mb-5">
																							Remover
																							<input
																								name={item.id + '_remove'}
																								className="checkbox-form"
																								type="checkbox"
																								onChange={handleSingleCheck}
																								defaultChecked={item.remove}
																							/>
																							<span className="checkmark"></span>
																						</label>
																					</li>
																					:
																					null
																			}
																			{
																				item.dash !== undefined ?
																					<li>
																						<label className="div-checkbox fs-5 mb-3">
																							Dashboard
																							<input
																								name={item.id + '_dash'}
																								className="checkbox-form"
																								type="checkbox"
																								onChange={handleSingleCheck}
																								defaultChecked={item.dash}
																							/>
																							<span className="checkmark"></span>
																						</label>
																					</li>
																					:
																					null
																			}
																			{
																				item.admin !== undefined ?
																					<li>
																						<label className="div-checkbox fs-5 mb-3">
																							Admin
																							<input
																								name={item.id + '_admin'}
																								className="checkbox-form"
																								type="checkbox"
																								onChange={handleSingleCheck}
																								defaultChecked={item.admin}
																							/>
																							<span className="checkmark"></span>
																						</label>
																					</li>
																					:
																					null
																			}
																		</ul>
																		// :
																		// 	null
																	}
																</span>
															</div>
															<div>
																{
																	item.submenu.map((sub, key2) => {
																		//console.log('SUB', sub.title)
																		//console.log('SUB', sub.apreciation)
																		if (sub.title === '')
																			return <div key={key2}></div>
																		else
																			return (
																				<div key={key2} className="form-group mt-3">
																					<span className="flex-1">
																						<div className='d-flex'>
																							<i className={"bi bi-dash-lg fs-5 me-4 invisible"}></i>
																							<label key={sub.id} className="div-checkbox fs-5">
																								<i className={"bi bi-dash-lg fs-5 me-2"}></i> {sub.title}
																								<input
																									name={sub.id}
																									className="checkbox-form"
																									type="checkbox"
																									value={sub.title}
																									onChange={handleSingleCheck}
																									defaultChecked={sub.allow === true ? true : false}
																								/>
																								<span className="checkmark"></span>
																							</label>
																						</div>
																					</span>
																					{// sub.title.includes('Lista') ?
																						<span className="flex-2">
																							{/*{console.log('SUB1001', sub)}*/}
																							<ul className='list-unstyled'>
																								{
																									sub.create !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Criar
																												<input
																													name={sub.id + '_create'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.create}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.edit !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Editar
																												<input
																													name={sub.id + '_edit'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.edit}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.remove !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-5">
																												Remover
																												<input
																													name={sub.id + '_remove'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.remove}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.dash !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Dashboard
																												<input
																													name={sub.id + '_dash'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.dash}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.admin !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Admin
																												<input
																													name={sub.id + '_admin'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.admin}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.identificacao !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Identificacao
																												<input
																													name={sub.id + '_identificacao'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.identificacao}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.interlocutores !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Interlocutores
																												<input
																													name={sub.id + '_interlocutores'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.interlocutores}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.naturalidade !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Naturalidade
																												<input
																													name={sub.id + '_naturalidade'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.naturalidade}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.fiscal !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Fiscal
																												<input
																													name={sub.id + '_fiscal'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.fiscal}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.associacao !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Associacao
																												<input
																													name={sub.id + '_associacao'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.associacao}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.contrato !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Contrato
																												<input
																													name={sub.id + '_contrato'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.contrato}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.funcoes !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Funcoes
																												<input
																													name={sub.id + '_funcoes'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.funcoes}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																								{
																									sub.configuracoes !== undefined ?
																										<li>
																											<label className="div-checkbox fs-5 mb-3">
																												Configuracoes
																												<input
																													name={sub.id + '_configuracoes'}
																													className="checkbox-form"
																													type="checkbox"
																													onChange={handleSingleCheck}
																													defaultChecked={sub.configuracoes}
																												/>
																												<span className="checkmark"></span>
																											</label>
																										</li>
																										:
																										null
																								}
																							</ul>
																						</span>
																						//:
																						//	null
																					}
																				</div>
																			)
																	})
																}
															</div>
														</div>
													)
											}
											)
											:
											null
									}
								</span>
							</div>
						</form>

					</div>
				</div>
			</div>

			<div className={'dash-cards-2 footer'}>
				<nav className="navbar bottom-navbar navbar-light">
					<div className="navbar-footer">
						<ul className="navbar-nav float-left"></ul>
						<ul className="navbar-nav float-right">
							<li className="nav-item">
								<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>Voltar</span>
								</Link>
							</li>
							{/* <li className={"nav-item "}>
								<button onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
									<i className="bi bi-trash3 me-2"></i>
									<span>Eliminar</span>
								</button>
							</li> */}
							<li className="nav-item">
								<button type="submit" form="form" className="nav-link">
									<i className="bi bi-floppy me-2"></i>
									<span>{save_label}</span>
								</button>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</main>
}
